import { createAuthClient } from 'better-auth/client'
import { twoFactorClient } from "better-auth/client/plugins";

export const authClient = createAuthClient({
    baseURL: import.meta.env.VITE_API_BACKEND_URL,
    plugins: [
        twoFactorClient({
            twoFactorRedirect: "/2fa/verify",
        }),
    ],
})